import { authInstance } from './fbase';

export default authInstance;